import axios from 'axios';
import authHeader from "@/service/auth-header";

class InvoiceService {

    async getCompanyInvoices(companyId) {
        return await axios.get(`/api/invoice1/active/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyUnpaidInvoices(companyId) {
        return await axios.get(`/api/invoice1/unpaid/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyUnpaidInvoicesForClient(companyId, clientId) {
        return await axios.get(`/api/invoice1/unpaid/${companyId}/${clientId}`,{ headers: authHeader() })
    }

    async getCompanyPaidInvoices(companyId) {
        return await axios.get(`/api/invoice1/paid/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyArchivedInvoices(companyId) {
        return await axios.get(`/api/invoice1/archived/${companyId}`,{ headers: authHeader() })
    }

    async getAllCompanyInvoices(companyId) {
        return await axios.get(`/api/invoice1/all/${companyId}`,{ headers: authHeader() })
    }

    async getAllCompanyInvoicesLazyLoading(companyId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'invoiced';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/invoice1/all/lazyloading/${companyId}`;

            console.log("[InvoiceService][getAllCompanyInvoicesLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[InvoiceService][getAllCompanyInvoicesLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    async getCompanyAffiliateInvoices(companyId, clientId) {
        return await axios.get(`/api/invoice1/${companyId}/affiliate/${clientId}`,{ headers: authHeader() })
    }

    async getAllPractitionerInvoices(practitionerId) {
        return await axios.get(`/api/invoice1/all/practitioner/${practitionerId}`,{ headers: authHeader() })
    }

    async getAllPractitionerInvoicesLazyLoading(practitionerId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'invoiced';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/invoice1/all/practitioner/lazyloading/${practitionerId}`;

            console.log("[InvoiceService][getAllPractitionerInvoicesLazyLoading]",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[InvoiceService][getAllPractitionerInvoicesLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    async getCompanyInvoicesForBillingRun(companyId, billingRunId) {
        return await axios.get(`/api/invoice1/${companyId}/billingrun/${billingRunId}`,{ headers: authHeader() })
    }

    async getCompanyInvoicesForUnpaidRun(companyId, unpaidRunId) {
        return await axios.get(`/api/invoice1/${companyId}/unpaidrun/${unpaidRunId}`,{ headers: authHeader() })
    }

    async getInvoiceInfoForBillingRun(companyId, billingRunId) {
        return await axios.get(`/api/invoice1/${companyId}/billingrun/invoiceinfo/${billingRunId}`,{ headers: authHeader() })
    }

    async getInvoiceInfoForUnpaidRun(companyId, unpaidRunId) {
        return await axios.get(`/api/invoice1/${companyId}/unpaidrun/invoiceinfo/${unpaidRunId}`,{ headers: authHeader() })
    }

    async getInvoice(invoiceId) {
        return await axios.get(`/api/invoice1/specific/${invoiceId}`,{ headers: authHeader() })
    }

    async getInvoiceforAppointment(appointmentId) {
        return await axios.get(`/api/invoice1/appointment/${appointmentId}`,{ headers: authHeader() })
    }

    async createInvoice(companyId, data) {
        const idk = (crypto?.randomUUID?.() ?? Date.now() + ':' + Math.random());

        return await axios.post(`/api/invoice1/${companyId}`, data,{ headers: authHeader(), 'Idempotency-Key': idk });
    }

    async createInvoiceForProduct(clientId, data) {
        return await axios.post(`/api/invoice1/${clientId}/product`, data,{ headers: authHeader() });
    }

    async createInvoiceForBillingPlan(clientId, data) {
        return await axios.post(`/api/invoice1/${clientId}/billingplan`, data,{ headers: authHeader() });
    }

    async emailInvoice(invoiceId, data) {
        return await axios.post(`/api/invoice1/email/${invoiceId}`, data,{ headers: authHeader() });
    }

    async downloadInvoice(invoiceId) {
        return await axios.get(`/api/invoice1/download/${invoiceId}`, {
            headers: authHeader(),
            responseType: 'blob', // Set the responseType to 'blob'
        });
    }

    async updateInvoice(invoiceId, data) {
        return await axios.put(`/api/invoice1/${invoiceId}`, data,{ headers: authHeader() });
    }

    async addBillingPlanToInvoice(invoiceId, useTaxRate, billingPlanId) {
        return await axios.post(`/api/invoice1/billingplan/${invoiceId}/${useTaxRate}/${billingPlanId}`, null,{ headers: authHeader() });
    }

    async addProductToInvoice(invoiceId, useTaxRate, productId) {
        return await axios.post(`/api/invoice1/product/${invoiceId}/${useTaxRate}/${productId}`, null,{ headers: authHeader() });
    }

    async cancelInvoice(invoiceId) {
        return await axios.delete(`/api/invoice1/${invoiceId}`,{ headers: authHeader() })
    }

    async deleteInvoice(invoiceId) {
        return await axios.delete(`/api/invoice1/${invoiceId}`,{ headers: authHeader() })
    }

    async getPayNowLink(invoiceId) {
        return await axios.get(`/api/invoice1/paynowlink/${invoiceId}`,{ headers: authHeader() })
    }

    async getGbpPayNowLink(invoiceId) {
        return await axios.get(`/api/invoice1/gbppaynowlink/${invoiceId}`,{ headers: authHeader() })
    }

    async getUsdPayNowLink(invoiceId) {
        return await axios.get(`/api/invoice1/usdpaynowlink/${invoiceId}`,{ headers: authHeader() })
    }
}

export default new InvoiceService();
